import React from 'react';
import {
    Card,
    CardHeader,
    CardContent,
    Divider,
    Collapse,
    IconButton,
    Typography,
    Box
} from '@mui/material';
import DescriptionIcon from '@mui/icons-material/Description';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ReactQuill from 'react-quill';
import 'quill/dist/quill.snow.css';

const QUILL_MODULES = {
    toolbar: [
        [{ header: '1' }, { header: '2' }, { font: [] }],
        [{ list: 'ordered' }, { list: 'bullet' }],
        ['bold', 'italic', 'underline'],
        [{ align: [] }],
        ['link'],
        ['clean']
    ]
};

const CreditContent = ({
    formData,
    handleCreditContent1Change,
    handleCreditContent2Change,
    expanded,
    toggleSection
}) => {

    return (
        <Card
            elevation={3}
            sx={{
                mb: 3,
                borderLeft: '6px solid #ff9800',
                borderRadius: 2,
                backgroundColor: '#fffaf3'
            }}
        >
            <CardHeader
                avatar={<DescriptionIcon sx={{ color: '#ff9800' }} />}
                title={
                    <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#000' }}>
                        Credit Plan Content
                    </Typography>
                }
                action={
                    <IconButton onClick={() => toggleSection('creditContent')}>
                        {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                    </IconButton>
                }
                sx={{
                    backgroundColor: '#fff3e0',
                    borderTopLeftRadius: 8,
                    borderTopRightRadius: 8,
                    py: 1.5,
                    px: 2
                }}
            />
            <Divider />
            <Collapse in={expanded}>
                <CardContent sx={{ px: 3, py: 2 }}>
                    <Box sx={{ mb: 4 }}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
                            Content Box 1
                        </Typography>
                        <Box sx={{ border: '1px solid #ffe0b2', borderRadius: 2, overflow: 'hidden', bgcolor: '#fff' }}>
                            <ReactQuill
                                theme="snow"
                                value={formData.content_box_1 || ''}
                                onChange={handleCreditContent1Change}
                                modules={QUILL_MODULES}
                                placeholder="Enter first content section..."
                            />
                        </Box>
                    </Box>

                    <Box>
                        <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
                            Content Box 2
                        </Typography>
                        <Box sx={{ border: '1px solid #ffe0b2', borderRadius: 2, overflow: 'hidden', bgcolor: '#fff' }}>
                            <ReactQuill
                                theme="snow"
                                value={formData.content_box_2 || ''}
                                onChange={handleCreditContent2Change}
                                modules={QUILL_MODULES}
                                placeholder="Enter second content section..."
                            />
                        </Box>
                    </Box>
                </CardContent>
            </Collapse>
        </Card>
    );
};

export default CreditContent;
